<div *ngIf="loading" class="d-flex justify-content-center align-items-center py-5">
  <app-spinner></app-spinner>
</div>

<ng-container *ngIf="!loading">
  <div class="cxr">

    <div class="cxr-nav">
      <button class="cxr-quit-btn" (click)="close()">
        <i class="fa-solid fa-arrow-left"></i>
        <span translate>Retour au parcours</span>
      </button>
    </div>

    <!-- Bilan -->
    <div class="cxr-summary mb-4" [class.cxr-summary--passed]="result.isPassed" [class.cxr-summary--failed]="!result.isPassed">

      <div class="cxr-circle">
        <app-progress-circle [percent]="result.score" [radius]="60" [title]="result.score + '%'"></app-progress-circle>
      </div>

      <div class="cxr-verdict">
        <div class="cxr-cefrl">{{ result.cefrl }}</div>
        <div class="cxr-verdict-badge" [class.cxr-verdict-badge--passed]="result.isPassed" [class.cxr-verdict-badge--failed]="!result.isPassed">
          <i class="fa-solid" [class.fa-circle-check]="result.isPassed" [class.fa-circle-xmark]="!result.isPassed"></i>
          <span *ngIf="result.isPassed" translate>Examen réussi</span>
          <span *ngIf="!result.isPassed" translate>Examen non validé</span>
        </div>
        <div class="cxr-threshold">
          <span translate>Seuil de réussite</span> : {{ result.successScore }}%
        </div>
        <div class="cxr-date" *ngIf="result.date">
          {{ result.date | date:'dd/MM/yyyy' }}
        </div>
      </div>

      <div class="cxr-actions" *ngIf="hasNextStep">
        <button class="cxr-btn-next" (click)="goToNextStep()">
          <span *ngIf="result.nextStep.type === 'section'" translate>Passer à la section suivante</span>
          <span *ngIf="result.nextStep.type !== 'section'" translate>Continuer le parcours</span>
          <i class="fa-solid fa-arrow-right ml-2"></i>
        </button>
      </div>

    </div>

    <!-- Skip du parcours : l'examen réussi a avancé l'utilisateur -->
    <div class="cxr-skip mb-4" *ngIf="result.isPassed && unlockedLevels">
      <i class="fa-solid fa-unlock cxr-skip-icon"></i>
      <div class="cxr-skip-text">
        <div class="cxr-skip-title">
          <span translate>Bravo, tu as débloqué le palier</span> {{ result.cefrl }} !
        </div>
        <div class="cxr-skip-subtitle" translate>
          Tous les niveaux jusqu'à cet examen sont désormais validés : tu reprends le parcours à l'étape suivante.
        </div>
      </div>
    </div>

    <!-- Correction détaillée -->
    <div class="cxr-corrections" *ngIf="result.questions?.length">

      <div class="cxr-corrections-title" translate>Correction détaillée</div>

      <div class="cxr-question mb-3"
           *ngFor="let question of result.questions; trackBy: trackByIndex"
           [class.cxr-question--correct]="question.isCorrect"
           [class.cxr-question--wrong]="!question.isCorrect">

        <div class="cxr-question-head">
          <div class="cxr-question-pin"
               [class.cxr-question-pin--correct]="question.isCorrect"
               [class.cxr-question-pin--wrong]="!question.isCorrect">
            {{ question.position }}
          </div>
          <div class="cxr-question-instruction">{{ question.instruction }}</div>
        </div>

        <div class="cxr-question-title" *ngIf="question.title">{{ question.title }}</div>

        <div class="cxr-question-statement" *ngIf="question.questionTranslation">
          {{ question.questionTranslation }}
        </div>

        <div class="cxr-question-audio" *ngIf="question.questionAudio">
          <button class="cxr-audio-btn" (click)="audioSrv.play(question.questionAudio)">
            <i class="fa-solid fa-volume-high"></i>
          </button>
        </div>

        <div class="cxr-question-answers">
          <div class="cxr-answer-line">
            <span class="cxr-answer-label" translate>Ta réponse</span>
            <span class="cxr-answer-value" *ngIf="answerGiven(question)"
                  [class.cxr-answer-value--correct]="question.isCorrect"
                  [class.cxr-answer-value--wrong]="!question.isCorrect">{{ answerGiven(question) }}</span>
            <span class="cxr-answer-value cxr-answer-value--empty" *ngIf="!answerGiven(question)" translate>Aucune réponse</span>
          </div>
          <div class="cxr-answer-line" *ngIf="!question.isCorrect && question.correctAnswers?.length">
            <span class="cxr-answer-label" translate>Bonne réponse</span>
            <span class="cxr-answer-value cxr-answer-value--correct">{{ question.correctAnswers.join(' / ') }}</span>
          </div>
        </div>

      </div>

    </div>

  </div>
</ng-container>
